
import { WorldCountry } from '../types';

export const finalEuropeCountries2: WorldCountry[] = [
  {
    code: 'FI',
    name: 'Finland',
    slug: 'finland',
    population: 5540720,
    topCities: [
      { name: 'Helsinki', slug: 'helsinki', population: 658457 },
      { name: 'Espoo', slug: 'espoo', population: 292796 },
      { name: 'Tampere', slug: 'tampere', population: 238245 },
      { name: 'Vantaa', slug: 'vantaa', population: 237422 },
      { name: 'Oulu', slug: 'oulu', population: 208939 },
      { name: 'Turku', slug: 'turku', population: 194244 },
      { name: 'Jyväskylä', slug: 'jyvaskyla', population: 143420 },
      { name: 'Lahti', slug: 'lahti', population: 119450 },
      { name: 'Kuopio', slug: 'kuopio', population: 118627 },
      { name: 'Pori', slug: 'pori', population: 83584 },
      { name: 'Joensuu', slug: 'joensuu', population: 76595 },
      { name: 'Lappeenranta', slug: 'lappeenranta', population: 72836 },
      { name: 'Hämeenlinna', slug: 'hameenlinna', population: 67794 },
      { name: 'Vaasa', slug: 'vaasa', population: 67606 },
      { name: 'Seinäjoki', slug: 'seinajoki', population: 63372 },
      { name: 'Rovaniemi', slug: 'rovaniemi', population: 63100 },
      { name: 'Mikkeli', slug: 'mikkeli', population: 54813 },
      { name: 'Kotka', slug: 'kotka', population: 52763 },
      { name: 'Salo', slug: 'salo', population: 52193 },
      { name: 'Porvoo', slug: 'porvoo', population: 50435 },
      { name: 'Kouvola', slug: 'kouvola', population: 82418 },
      { name: 'Hyvinkää', slug: 'hyvinkaa', population: 46598 },
      { name: 'Savonlinna', slug: 'savonlinna', population: 34778 },
      { name: 'Kajaani', slug: 'kajaani', population: 37084 },
      { name: 'Iisalmi', slug: 'iisalmi', population: 21726 },
      { name: 'Varkaus', slug: 'varkaus', population: 20456 },
      { name: 'Kemi', slug: 'kemi', population: 20654 },
      { name: 'Tornio', slug: 'tornio', population: 21693 },
      { name: 'Riihimäki', slug: 'riihimaki', population: 29123 },
      { name: 'Imatra', slug: 'imatra', population: 26084 },
      { name: 'Raahe', slug: 'raahe', population: 25641 },
      { name: 'Kirkkonummi', slug: 'kirkkonummi', population: 40178 },
      { name: 'Järvenpää', slug: 'jarvenpaa', population: 44389 },
      { name: 'Kerava', slug: 'kerava', population: 36146 },
      { name: 'Tuusula', slug: 'tuusula', population: 38872 },
      { name: 'Sipoo', slug: 'sipoo', population: 21899 },
      { name: 'Vihti', slug: 'vihti', population: 29021 },
      { name: 'Nurmijärvi', slug: 'nurmijarvi', population: 43030 },
      { name: 'Mäntsälä', slug: 'mantsala', population: 21227 },
      { name: 'Kauniainen', slug: 'kauniainen', population: 9812 },
      { name: 'Lohja', slug: 'lohja', population: 46456 },
      { name: 'Karkkila', slug: 'karkkila', population: 9021 },
      { name: 'Hanko', slug: 'hanko', population: 8654 },
      { name: 'Raasepori', slug: 'raasepori', population: 27987 },
      { name: 'Loviisa', slug: 'loviisa', population: 14832 },
      { name: 'Askola', slug: 'askola', population: 5098 },
      { name: 'Lapinjärvi', slug: 'lapinjarvi', population: 2827 },
      { name: 'Myrskylä', slug: 'myrskyla', population: 2098 },
      { name: 'Pukkila', slug: 'pukkila', population: 2021 },
      { name: 'Pornainen', slug: 'pornainen', population: 5156 },
      { name: 'Forssa', slug: 'forssa', population: 17063 },
      { name: 'Humppila', slug: 'humppila', population: 2398 },
      { name: 'Jokioinen', slug: 'jokioinen', population: 5654 },
      { name: 'Tammela', slug: 'tammela', population: 6234 },
      { name: 'Ypäjä', slug: 'ypaja', population: 2543 },
      { name: 'Somero', slug: 'somero', population: 9123 },
      { name: 'Marttila', slug: 'marttila', population: 2087 },
      { name: 'Mynämäki', slug: 'mynamaki', population: 8654 },
      { name: 'Nousiainen', slug: 'nousiainen', population: 4987 },
      { name: 'Paimio', slug: 'paimio', population: 10876 },
      { name: 'Raisio', slug: 'raisio', population: 24654 },
      { name: 'Rusko', slug: 'rusko', population: 6234 },
      { name: 'Sauvo', slug: 'sauvo', population: 3098 },
      { name: 'Lieto', slug: 'lieto', population: 18765 },
      { name: 'Masku', slug: 'masku', population: 10234 },
      { name: 'Naantali', slug: 'naantali', population: 19456 },
      { name: 'Aura', slug: 'aura', population: 4123 },
      { name: 'Koski', slug: 'koski', population: 2456 },
      { name: 'Laitila', slug: 'laitila', population: 8543 },
      { name: 'Pyhäranta', slug: 'pyharanta', population: 2234 },
      { name: 'Uusikaupunki', slug: 'uusikaupunki', population: 15234 },
      { name: 'Vehmaa', slug: 'vehmaa', population: 2198 },
      { name: 'Kustavi', slug: 'kustavi', population: 876 },
      { name: 'Taivassalo', slug: 'taivassalo', population: 1654 },
      { name: 'Kemiönsaari', slug: 'kemionsaari', population: 6987 },
      { name: 'Parainen', slug: 'parainen', population: 15432 },
      { name: 'Kaarina', slug: 'kaarina', population: 24876 },
      { name: 'Piikkiö', slug: 'piikkio', population: 7234 },
      { name: 'Korppoo', slug: 'korppoo', population: 876 },
      { name: 'Nauvo', slug: 'nauvo', population: 1456 },
      { name: 'Kimitoön', slug: 'kimitoon', population: 6789 },
      { name: 'Särkisalo', slug: 'sarkisalo', population: 654 },
      { name: 'Suomusjärvi', slug: 'suomusjarvi', population: 1234 },
      { name: 'Alastaro', slug: 'alastaro', population: 2876 },
      { name: 'Koski Tl', slug: 'koski-tl', population: 2456 },
      { name: 'Loimaa', slug: 'loimaa', population: 16789 },
      { name: 'Mellilä', slug: 'mellila', population: 1234 },
      { name: 'Oripää', slug: 'oripaa', population: 1456 },
      { name: 'Pöytyä', slug: 'poytya', population: 8765 },
      { name: 'Yläne', slug: 'ylane', population: 2098 },
      { name: 'Hämeenkoski', slug: 'hameenkoski', population: 2087 },
      { name: 'Heinola', slug: 'heinola', population: 19234 },
      { name: 'Hartola', slug: 'hartola', population: 3098 },
      { name: 'Sysmä', slug: 'sysma', population: 4123 },
      { name: 'Asikkala', slug: 'asikkala', population: 8234 },
      { name: 'Padasjoki', slug: 'padasjoki', population: 3456 },
      { name: 'Kärkölä', slug: 'karkola', population: 4789 },
      { name: 'Hollola', slug: 'hollola', population: 22345 },
      { name: 'Nastola', slug: 'nastola', population: 14876 },
      { name: 'Orimattila', slug: 'orimattila', population: 16234 },
      { name: 'Artjärvi', slug: 'artjarvi', population: 1345 },
      { name: 'Myrskylä', slug: 'myrskyla-2', population: 2098 },
      { name: 'Hämeenkyrö', slug: 'hameenkyro', population: 10876 },
      { name: 'Ikaalinen', slug: 'ikaalinen', population: 7234 },
      { name: 'Kihniö', slug: 'kihnio', population: 2098 },
      { name: 'Parkano', slug: 'parkano', population: 6789 },
      { name: 'Virrat', slug: 'virrat', population: 6543 },
      { name: 'Ylöjärvi', slug: 'ylojarvi', population: 32876 }
    ]
  },
  {
    code: 'CH',
    name: 'Switzerland',
    slug: 'switzerland',
    population: 8776000,
    topCities: [
      { name: 'Zurich', slug: 'zurich', population: 421878 },
      { name: 'Geneva', slug: 'geneva', population: 201818 },
      { name: 'Basel', slug: 'basel', population: 177595 },
      { name: 'Lausanne', slug: 'lausanne', population: 139111 },
      { name: 'Bern', slug: 'bern', population: 133883 },
      { name: 'Winterthur', slug: 'winterthur', population: 114220 },
      { name: 'Lucerne', slug: 'lucerne', population: 82257 },
      { name: 'St. Gallen', slug: 'st-gallen', population: 75833 },
      { name: 'Lugano', slug: 'lugano', population: 62315 },
      { name: 'Biel/Bienne', slug: 'biel-bienne', population: 55206 },
      { name: 'Thun', slug: 'thun', population: 43476 },
      { name: 'Köniz', slug: 'koniz', population: 41965 },
      { name: 'La Chaux-de-Fonds', slug: 'la-chaux-de-fonds', population: 36915 },
      { name: 'Schaffhausen', slug: 'schaffhausen', population: 36952 },
      { name: 'Fribourg', slug: 'fribourg', population: 38365 },
      { name: 'Vernier', slug: 'vernier', population: 35088 },
      { name: 'Chur', slug: 'chur', population: 36336 },
      { name: 'Neuchâtel', slug: 'neuchatel', population: 33712 },
      { name: 'Uster', slug: 'uster', population: 35337 },
      { name: 'Sion', slug: 'sion', population: 34978 },
      { name: 'Emmen', slug: 'emmen', population: 30806 },
      { name: 'Yverdon-les-Bains', slug: 'yverdon-les-bains', population: 30143 },
      { name: 'Zug', slug: 'zug', population: 30934 },
      { name: 'Kriens', slug: 'kriens', population: 27735 },
      { name: 'Rapperswil-Jona', slug: 'rapperswil-jona', population: 27582 },
      { name: 'Dübendorf', slug: 'dubendorf', population: 28129 },
      { name: 'Montreux', slug: 'montreux', population: 26574 },
      { name: 'Frauenfeld', slug: 'frauenfeld', population: 25010 },
      { name: 'Dietikon', slug: 'dietikon', population: 26305 },
      { name: 'Riehen', slug: 'riehen', population: 21242 },
      { name: 'Wettingen', slug: 'wettingen', population: 20719 },
      { name: 'Allschwil', slug: 'allschwil', population: 21518 },
      { name: 'Renens', slug: 'renens', population: 21036 },
      { name: 'Kreuzlingen', slug: 'kreuzlingen', population: 22518 },
      { name: 'Bellinzona', slug: 'bellinzona', population: 18156 },
      { name: 'Baar', slug: 'baar', population: 24221 },
      { name: 'Delémont', slug: 'delemont', population: 12463 },
      { name: 'Wädenswil', slug: 'wadenswil', population: 21398 },
      { name: 'La Tour-de-Peilz', slug: 'la-tour-de-peilz', population: 11462 },
      { name: 'Carouge', slug: 'carouge', population: 22729 },
      { name: 'Meyrin', slug: 'meyrin', population: 23520 },
      { name: 'Kloten', slug: 'kloten', population: 19606 },
      { name: 'Wil', slug: 'wil', population: 24000 },
      { name: 'Nyon', slug: 'nyon', population: 20533 },
      { name: 'Olten', slug: 'olten', population: 17604 },
      { name: 'Pratteln', slug: 'pratteln', population: 16674 },
      { name: 'Lancy', slug: 'lancy', population: 31432 },
      { name: 'Steffisburg', slug: 'steffisburg', population: 15313 },
      { name: 'Volketswil', slug: 'volketswil', population: 18576 },
      { name: 'Horgen', slug: 'horgen', population: 22693 },
      { name: 'Gossau', slug: 'gossau', population: 17666 },
      { name: 'Monthey', slug: 'monthey', population: 17825 },
      { name: 'Martigny', slug: 'martigny', population: 18654 },
      { name: 'Burgdorf', slug: 'burgdorf', population: 16448 },
      { name: 'Thalwil', slug: 'thalwil', population: 17859 },
      { name: 'Reinach', slug: 'reinach', population: 18887 },
      { name: 'Bulle', slug: 'bulle', population: 23237 },
      { name: 'Solothurn', slug: 'solothurn', population: 16777 },
      { name: 'Grenchen', slug: 'grenchen', population: 16768 },
      { name: 'Langenthal', slug: 'langenthal', population: 15817 },
      { name: 'Schwyz', slug: 'schwyz', population: 15435 },
      { name: 'Muttenz', slug: 'muttenz', population: 17576 },
      { name: 'Morges', slug: 'morges', population: 15658 },
      { name: 'Baden', slug: 'baden', population: 19658 },
      { name: 'Vevey', slug: 'vevey', population: 19827 },
      { name: 'Adliswil', slug: 'adliswil', population: 18629 },
      { name: 'Sierre', slug: 'sierre', population: 16332 },
      { name: 'Opfikon', slug: 'opfikon', population: 20344 },
      { name: 'Versoix', slug: 'versoix', population: 13227 },
      { name: 'Freienbach', slug: 'freienbach', population: 16460 },
      { name: 'Ostermundigen', slug: 'ostermundigen', population: 17118 },
      { name: 'Liestal', slug: 'liestal', population: 14148 },
      { name: 'Herisau', slug: 'herisau', population: 15527 },
      { name: 'Arbon', slug: 'arbon', population: 14376 },
      { name: 'Binningen', slug: 'binningen', population: 15924 },
      { name: 'Le Locle', slug: 'le-locle', population: 10260 },
      { name: 'Einsiedeln', slug: 'einsiedeln', population: 15789 },
      { name: 'Worb', slug: 'worb', population: 11934 },
      { name: 'Zofingen', slug: 'zofingen', population: 11687 },
      { name: 'Littau', slug: 'littau', population: 17441 },
      { name: 'Schlieren', slug: 'schlieren', population: 18798 },
      { name: 'Gland', slug: 'gland', population: 13298 },
      { name: 'Wallisellen', slug: 'wallisellen', population: 15612 },
      { name: 'Küsnacht', slug: 'kusnacht', population: 14177 },
      { name: 'Cham', slug: 'cham', population: 16843 },
      { name: 'Onex', slug: 'onex', population: 18345 },
      { name: 'Pully', slug: 'pully', population: 17763 },
      { name: 'Ecublens', slug: 'ecublens', population: 12843 },
      { name: 'Mendrisio', slug: 'mendrisio', population: 15265 },
      { name: 'Locarno', slug: 'locarno', population: 15870 },
      { name: 'Aigle', slug: 'aigle', population: 10215 },
      { name: 'Le Grand-Saconnex', slug: 'le-grand-saconnex', population: 12634 },
      { name: 'Lyss', slug: 'lyss', population: 15062 },
      { name: 'Rheinfelden', slug: 'rheinfelden', population: 13333 },
      { name: 'Bülach', slug: 'bulach', population: 20599 },
      { name: 'Münsingen', slug: 'munsingen', population: 12147 },
      { name: 'Aarau', slug: 'aarau', population: 21726 },
      { name: 'Birsfelden', slug: 'birsfelden', population: 10628 },
      { name: 'Ebikon', slug: 'ebikon', population: 13634 },
      { name: 'Wohlen', slug: 'wohlen', population: 15789 },
      { name: 'Thônex', slug: 'thonex', population: 14582 },
      { name: 'Plan-les-Ouates', slug: 'plan-les-ouates', population: 10598 },
      { name: 'Ittigen', slug: 'ittigen', population: 11659 },
      { name: 'Bassersdorf', slug: 'bassersdorf', population: 12356 },
      { name: 'Spreitenbach', slug: 'spreitenbach', population: 11995 }
    ]
  },
  {
    code: 'AT',
    name: 'Austria',
    slug: 'austria',
    population: 9006398,
    topCities: [
      { name: 'Vienna', slug: 'vienna', population: 1897491 },
      { name: 'Graz', slug: 'graz', population: 291072 },
      { name: 'Linz', slug: 'linz', population: 206595 },
      { name: 'Salzburg', slug: 'salzburg', population: 155031 },
      { name: 'Innsbruck', slug: 'innsbruck', population: 132493 },
      { name: 'Klagenfurt', slug: 'klagenfurt', population: 100316 },
      { name: 'Villach', slug: 'villach', population: 62008 },
      { name: 'Wels', slug: 'wels', population: 62846 },
      { name: 'Sankt Pölten', slug: 'sankt-polten', population: 55740 },
      { name: 'Dornbirn', slug: 'dornbirn', population: 49845 },
      { name: 'Wiener Neustadt', slug: 'wiener-neustadt', population: 45590 },
      { name: 'Steyr', slug: 'steyr', population: 38120 },
      { name: 'Feldkirch', slug: 'feldkirch', population: 34145 },
      { name: 'Bregenz', slug: 'bregenz', population: 29698 },
      { name: 'Leonding', slug: 'leonding', population: 28468 },
      { name: 'Klosterneuburg', slug: 'klosterneuburg', population: 27691 },
      { name: 'Baden bei Wien', slug: 'baden-bei-wien', population: 25729 },
      { name: 'Wolfsberg', slug: 'wolfsberg', population: 25093 },
      { name: 'Leoben', slug: 'leoben', population: 24466 },
      { name: 'Krems an der Donau', slug: 'krems-an-der-donau', population: 24932 },
      { name: 'Traun', slug: 'traun', population: 24477 },
      { name: 'Amstetten', slug: 'amstetten', population: 23483 },
      { name: 'Kapfenberg', slug: 'kapfenberg', population: 22189 },
      { name: 'Mödling', slug: 'modling', population: 20610 },
      { name: 'Hallein', slug: 'hallein', population: 21467 },
      { name: 'Kufstein', slug: 'kufstein', population: 18536 },
      { name: 'Traiskirchen', slug: 'traiskirchen', population: 19576 },
      { name: 'Schwechat', slug: 'schwechat', population: 17425 },
      { name: 'Braunau am Inn', slug: 'braunau-am-inn', population: 17003 },
      { name: 'Stockerau', slug: 'stockerau', population: 16932 },
      { name: 'Saalfelden am Steinernen Meer', slug: 'saalfelden-am-steinernen-meer', population: 16723 },
      { name: 'Ansfelden', slug: 'ansfelden', population: 16194 },
      { name: 'Tulln an der Donau', slug: 'tulln-an-der-donau', population: 16582 },
      { name: 'Hohenems', slug: 'hohenems', population: 15898 },
      { name: 'Spittal an der Drau', slug: 'spittal-an-der-drau', population: 15456 },
      { name: 'Telfs', slug: 'telfs', population: 15632 },
      { name: 'Ternitz', slug: 'ternitz', population: 14589 },
      { name: 'Perchtoldsdorf', slug: 'perchtoldsdorf', population: 14895 },
      { name: 'Bischofshofen', slug: 'bischofshofen', population: 10123 },
      { name: 'Groß-Enzersdorf', slug: 'gross-enzersdorf', population: 10234 },
      { name: 'Sankt Veit an der Glan', slug: 'sankt-veit-an-der-glan', population: 12576 },
      { name: 'Korneuburg', slug: 'korneuburg', population: 12932 },
      { name: 'Neunkirchen', slug: 'neunkirchen', population: 12789 },
      { name: 'Hard', slug: 'hard', population: 13456 },
      { name: 'Vöcklabruck', slug: 'vocklabruck', population: 12789 },
      { name: 'Lienz', slug: 'lienz', population: 11876 },
      { name: 'Rankweil', slug: 'rankweil', population: 11678 },
      { name: 'Hollabrunn', slug: 'hollabrunn', population: 11234 },
      { name: 'Enns', slug: 'enns', population: 11789 },
      { name: 'Schwaz', slug: 'schwaz', population: 13456 },
      { name: 'Lustenau', slug: 'lustenau', population: 22456 },
      { name: 'Sankt Johann im Pongau', slug: 'sankt-johann-im-pongau', population: 11123 },
      { name: 'Götzis', slug: 'gotzis', population: 11456 },
      { name: 'Seekirchen am Wallersee', slug: 'seekirchen-am-wallersee', population: 10789 },
      { name: 'Feldkirchen in Kärnten', slug: 'feldkirchen-in-karnten', population: 14567 },
      { name: 'Bludenz', slug: 'bludenz', population: 14234 },
      { name: 'Bad Ischl', slug: 'bad-ischl', population: 13987 },
      { name: 'Eisenstadt', slug: 'eisenstadt', population: 14681 },
      { name: 'Brunn am Gebirge', slug: 'brunn-am-gebirge', population: 12456 },
      { name: 'Deutsch-Wagram', slug: 'deutsch-wagram', population: 8123 },
      { name: 'Bruck an der Mur', slug: 'bruck-an-der-mur', population: 12789 },
      { name: 'Mondsee', slug: 'mondsee', population: 3456 },
      { name: 'Wörgl', slug: 'worgl', population: 13234 },
      { name: 'Ried im Innkreis', slug: 'ried-im-innkreis', population: 11876 },
      { name: 'Gmunden', slug: 'gmunden', population: 13567 },
      { name: 'Fürstenfeld', slug: 'furstenfeld', population: 5789 },
      { name: 'Völkermarkt', slug: 'volkermarkt', population: 10234 },
      { name: 'Judenburg', slug: 'judenburg', population: 9876 },
      { name: 'Weiz', slug: 'weiz', population: 11234 },
      { name: 'Hartberg', slug: 'hartberg', population: 6789 },
      { name: 'Mistelbach', slug: 'mistelbach', population: 11234 },
      { name: 'Sankt Andrä', slug: 'sankt-andra', population: 4567 },
      { name: 'Gänserndorf', slug: 'ganserndorf', population: 10456 },
      { name: 'Melk', slug: 'melk', population: 5234 },
      { name: 'Laa an der Thaya', slug: 'laa-an-der-thaya', population: 6123 },
      { name: 'Zwettl', slug: 'zwettl', population: 11234 },
      { name: 'Waidhofen an der Ybbs', slug: 'waidhofen-an-der-ybbs', population: 11345 },
      { name: 'Horn', slug: 'horn', population: 6234 },
      { name: 'Gmünd', slug: 'gmund', population: 5456 },
      { name: 'Oberwart', slug: 'oberwart', population: 7123 },
      { name: 'Güssing', slug: 'gussing', population: 3789 },
      { name: 'Jennersdorf', slug: 'jennersdorf', population: 4234 },
      { name: 'Mattersburg', slug: 'mattersburg', population: 7456 },
      { name: 'Neusiedl am See', slug: 'neusiedl-am-see', population: 8234 },
      { name: 'Rust', slug: 'rust', population: 1876 },
      { name: 'Purkersdorf', slug: 'purkersdorf', population: 9123 },
      { name: 'Mauerbach', slug: 'mauerbach', population: 4234 },
      { name: 'Pressbaum', slug: 'pressbaum', population: 6789 },
      { name: 'Tullnerbach', slug: 'tullnerbach', population: 3456 },
      { name: 'Maria Enzersdorf', slug: 'maria-enzersdorf', population: 8765 },
      { name: 'Berndorf', slug: 'berndorf', population: 8234 },
      { name: 'Pottenstein', slug: 'pottenstein', population: 3123 },
      { name: 'Hainfeld', slug: 'hainfeld', population: 3789 },
      { name: 'Wilhelmsburg', slug: 'wilhelmsburg', population: 6234 },
      { name: 'Haag', slug: 'haag', population: 5456 },
      { name: 'Ybbsitz', slug: 'ybbsitz', population: 3234 },
      { name: 'Scheibbs', slug: 'scheibbs', population: 4789 },
      { name: 'Gaming', slug: 'gaming', population: 3456 },
      { name: 'Purgstall', slug: 'purgstall', population: 5234 },
      { name: 'Wieselburg', slug: 'wieselburg', population: 3876 },
      { name: 'Euratsfeld', slug: 'euratsfeld', population: 2987 },
      { name: 'Aschbach-Markt', slug: 'aschbach-markt', population: 3654 },
      { name: 'Ardagger', slug: 'ardagger', population: 3234 },
      { name: 'Wallsee', slug: 'wallsee', population: 2145 },
      { name: 'Strengberg', slug: 'strengberg', population: 1987 },
      { name: 'Seitenstetten', slug: 'seitenstetten', population: 3456 },
      { name: 'Grein', slug: 'grein', population: 3098 },
      { name: 'Persenbeug-Gottsdorf', slug: 'persenbeug-gottsdorf', population: 2765 }
    ]
  },
  {
    code: 'BE',
    name: 'Belgium',
    slug: 'belgium',
    population: 11589623,
    topCities: [
      { name: 'Brussels', slug: 'brussels', population: 1209000 },
      { name: 'Antwerp', slug: 'antwerp', population: 529247 },
      { name: 'Ghent', slug: 'ghent', population: 263927 },
      { name: 'Charleroi', slug: 'charleroi', population: 201816 },
      { name: 'Liège', slug: 'liege', population: 197013 },
      { name: 'Bruges', slug: 'bruges', population: 118284 },
      { name: 'Namur', slug: 'namur', population: 110570 },
      { name: 'Leuven', slug: 'leuven', population: 100244 },
      { name: 'Mons', slug: 'mons', population: 95939 },
      { name: 'Aalst', slug: 'aalst', population: 85740 },
      { name: 'La Louvière', slug: 'la-louviere', population: 79579 },
      { name: 'Kortrijk', slug: 'kortrijk', population: 76265 },
      { name: 'Hasselt', slug: 'hasselt', population: 76685 },
      { name: 'Sint-Niklaas', slug: 'sint-niklaas', population: 76824 },
      { name: 'Ostend', slug: 'ostend', population: 70584 },
      { name: 'Genk', slug: 'genk', population: 66557 },
      { name: 'Seraing', slug: 'seraing', population: 64205 },
      { name: 'Roeselare', slug: 'roeselare', population: 63032 },
      { name: 'Verviers', slug: 'verviers', population: 55740 },
      { name: 'Mouscron', slug: 'mouscron', population: 58915 },
      { name: 'Beveren', slug: 'beveren', population: 48795 },
      { name: 'Dendermonde', slug: 'dendermonde', population: 46207 },
      { name: 'Beringen', slug: 'beringen', population: 45988 },
      { name: 'Turnhout', slug: 'turnhout', population: 42637 },
      { name: 'Vilvoorde', slug: 'vilvoorde', population: 44251 },
      { name: 'Lokeren', slug: 'lokeren', population: 41872 },
      { name: 'Sint-Truiden', slug: 'sint-truiden', population: 40500 },
      { name: 'Herstal', slug: 'herstal', population: 39020 },
      { name: 'Brasschaat', slug: 'brasschaat', population: 37702 },
      { name: 'Mechelen', slug: 'mechelen', population: 86304 },
      { name: 'Waregem', slug: 'waregem', population: 38183 },
      { name: 'Chatelet', slug: 'chatelet', population: 35633 },
      { name: 'Ieper', slug: 'ieper', population: 35089 },
      { name: 'Lommel', slug: 'lommel', population: 34476 },
      { name: 'Heist-op-den-Berg', slug: 'heist-op-den-berg', population: 44207 },
      { name: 'Menen', slug: 'menen', population: 33123 },
      { name: 'Ottignies-Louvain-la-Neuve', slug: 'ottignies-louvain-la-neuve', population: 31769 },
      { name: 'Geel', slug: 'geel', population: 40213 },
      { name: 'Schoten', slug: 'schoten', population: 34015 },
      { name: 'Aarschot', slug: 'aarschot', population: 29026 },
      { name: 'Mol', slug: 'mol', population: 36932 },
      { name: 'Ninove', slug: 'ninove', population: 37642 },
      { name: 'Tongeren', slug: 'tongeren', population: 30595 },
      { name: 'Waterloo', slug: 'waterloo', population: 29706 },
      { name: 'Gembloux', slug: 'gembloux', population: 26983 },
      { name: 'Binche', slug: 'binche', population: 32968 },
      { name: 'Wavre', slug: 'wavre', population: 33612 },
      { name: 'Fleurus', slug: 'fleurus', population: 22364 },
      { name: 'Braine-l\'Alleud', slug: 'braine-lalleud', population: 39265 },
      { name: 'Couvin', slug: 'couvin', population: 13479 },
      { name: 'Chimay', slug: 'chimay', population: 9774 },
      { name: 'Philippeville', slug: 'philippeville', population: 8654 },
      { name: 'Walcourt', slug: 'walcourt', population: 17456 },
      { name: 'Florennes', slug: 'florennes', population: 10987 },
      { name: 'Doische', slug: 'doische', population: 2876 },
      { name: 'Viroinval', slug: 'viroinval', population: 5432 },
      { name: 'Rochefort', slug: 'rochefort', population: 12345 },
      { name: 'Dinant', slug: 'dinant', population: 13654 },
      { name: 'Ciney', slug: 'ciney', population: 16234 },
      { name: 'Marche-en-Famenne', slug: 'marche-en-famenne', population: 17456 },
      { name: 'Bastogne', slug: 'bastogne', population: 15678 },
      { name: 'Vielsalm', slug: 'vielsalm', population: 7890 },
      { name: 'La Roche-en-Ardenne', slug: 'la-roche-en-ardenne', population: 4321 },
      { name: 'Houffalize', slug: 'houffalize', population: 4876 },
      { name: 'Saint-Vith', slug: 'saint-vith', population: 9234 },
      { name: 'Malmedy', slug: 'malmedy', population: 12567 },
      { name: 'Spa', slug: 'spa', population: 10432 },
      { name: 'Stavelot', slug: 'stavelot', population: 6789 },
      { name: 'Trois-Ponts', slug: 'trois-ponts', population: 2456 },
      { name: 'Stoumont', slug: 'stoumont', population: 3123 },
      { name: 'Lierneux', slug: 'lierneux', population: 3456 },
      { name: 'Gouvy', slug: 'gouvy', population: 4789 },
      { name: 'Manhay', slug: 'manhay', population: 3234 },
      { name: 'Erezée', slug: 'erezee', population: 2987 },
      { name: 'Hotton', slug: 'hotton', population: 5432 },
      { name: 'Rendeux', slug: 'rendeux', population: 2345 },
      { name: 'Tenneville', slug: 'tenneville', population: 2876 },
      { name: 'Wellin', slug: 'wellin', population: 2987 },
      { name: 'Tellin', slug: 'tellin', population: 2345 },
      { name: 'Libin', slug: 'libin', population: 4567 },
      { name: 'Saint-Hubert', slug: 'saint-hubert', population: 5678 },
      { name: 'Bouillon', slug: 'bouillon', population: 5432 },
      { name: 'Paliseul', slug: 'paliseul', population: 4876 },
      { name: 'Herbeumont', slug: 'herbeumont', population: 1876 },
      { name: 'Daverdisse', slug: 'daverdisse', population: 1345 },
      { name: 'Bertogne', slug: 'bertogne', population: 3098 },
      { name: 'Fauvillers', slug: 'fauvillers', population: 2134 },
      { name: 'Léglise', slug: 'leglise', population: 4567 },
      { name: 'Neufchâteau', slug: 'neufchateau', population: 7234 },
      { name: 'Habay', slug: 'habay', population: 8123 },
      { name: 'Etalle', slug: 'etalle', population: 5678 },
      { name: 'Virton', slug: 'virton', population: 11234 },
      { name: 'Rouvroy', slug: 'rouvroy', population: 1987 },
      { name: 'Tintigny', slug: 'tintigny', population: 3654 },
      { name: 'Saint-Léger', slug: 'saint-leger', population: 3234 },
      { name: 'Florenville', slug: 'florenville', population: 5432 },
      { name: 'Chiny', slug: 'chiny', population: 4987 },
      { name: 'Musson', slug: 'musson', population: 4321 },
      { name: 'Aubange', slug: 'aubange', population: 16789 },
      { name: 'Messancy', slug: 'messancy', population: 8123 },
      { name: 'Arlon', slug: 'arlon', population: 29750 },
      { name: 'Attert', slug: 'attert', population: 4876 },
      { name: 'Martelange', slug: 'martelange', population: 1654 },
      { name: 'Redange', slug: 'redange', population: 1876 },
      { name: 'Warnach', slug: 'warnach', population: 1234 },
      { name: 'Beckerich', slug: 'beckerich', population: 2345 },
      { name: 'Rambrouch', slug: 'rambrouch', population: 4567 },
      { name: 'Useldange', slug: 'useldange', population: 1876 }
    ]
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    slug: 'luxembourg',
    population: 640064,
    topCities: [
      { name: 'Luxembourg City', slug: 'luxembourg-city', population: 125622 },
      { name: 'Esch-sur-Alzette', slug: 'esch-sur-alzette', population: 36625 },
      { name: 'Differdange', slug: 'differdange', population: 26764 },
      { name: 'Dudelange', slug: 'dudelange', population: 21525 },
      { name: 'Ettelbruck', slug: 'ettelbruck', population: 9086 },
      { name: 'Diekirch', slug: 'diekirch', population: 7209 },
      { name: 'Strassen', slug: 'strassen', population: 10128 },
      { name: 'Bertrange', slug: 'bertrange', population: 8732 },
      { name: 'Bettembourg', slug: 'bettembourg', population: 11923 },
      { name: 'Schifflange', slug: 'schifflange', population: 10196 },
      { name: 'Pétange', slug: 'petange', population: 17901 },
      { name: 'Sanem', slug: 'sanem', population: 16734 },
      { name: 'Hesperange', slug: 'hesperange', population: 15198 },
      { name: 'Mondercange', slug: 'mondercange', population: 6821 },
      { name: 'Roeser', slug: 'roeser', population: 6298 },
      { name: 'Sandweiler', slug: 'sandweiler', population: 3876 },
      { name: 'Contern', slug: 'contern', population: 3654 },
      { name: 'Weiler-la-Tour', slug: 'weiler-la-tour', population: 2234 },
      { name: 'Dalheim', slug: 'dalheim', population: 1987 },
      { name: 'Emerange', slug: 'emerange', population: 1654 },
      { name: 'Kayl', slug: 'kayl', population: 8743 },
      { name: 'Rumelange', slug: 'rumelange', population: 4876 },
      { name: 'Käerjeng', slug: 'kaerjeng', population: 12654 },
      { name: 'Steinfort', slug: 'steinfort', population: 4987 },
      { name: 'Koerich', slug: 'koerich', population: 2654 },
      { name: 'Hobscheid', slug: 'hobscheid', population: 1876 },
      { name: 'Septfontaines', slug: 'septfontaines', population: 876 },
      { name: 'Garnich', slug: 'garnich', population: 2234 },
      { name: 'Dippach', slug: 'dippach', population: 4567 },
      { name: 'Reckange-sur-Mess', slug: 'reckange-sur-mess', population: 2345 },
      { name: 'Clemency', slug: 'clemency', population: 1876 },
      { name: 'Bascharage', slug: 'bascharage', population: 8765 },
      { name: 'Leudelange', slug: 'leudelange', population: 2345 },
      { name: 'Capellen', slug: 'capellen', population: 13456 },
      { name: 'Mamer', slug: 'mamer', population: 12654 },
      { name: 'Steinsel', slug: 'steinsel', population: 4987 },
      { name: 'Kopstal', slug: 'kopstal', population: 3876 },
      { name: 'Walferdange', slug: 'walferdange', population: 8234 },
      { name: 'Lintgen', slug: 'lintgen', population: 2987 },
      { name: 'Lorentzweiler', slug: 'lorentzweiler', population: 3654 },
      { name: 'Mersch', slug: 'mersch', population: 8765 },
      { name: 'Larochette', slug: 'larochette', population: 2234 },
      { name: 'Nommern', slug: 'nommern', population: 1234 },
      { name: 'Boevange-sur-Attert', slug: 'boevange-sur-attert', population: 1876 },
      { name: 'Tuntange', slug: 'tuntange', population: 987 },
      { name: 'Helperknapp', slug: 'helperknapp', population: 1543 },
      { name: 'Saeul', slug: 'saeul', population: 654 },
      { name: 'Grosbous', slug: 'grosbous', population: 876 },
      { name: 'Redange', slug: 'redange-lux', population: 1987 },
      { name: 'Ell', slug: 'ell', population: 1234 },
      { name: 'Préizerdaul', slug: 'preizerdaul', population: 2345 },
      { name: 'Useldange', slug: 'useldange-lux', population: 1765 },
      { name: 'Rambrouch', slug: 'rambrouch-lux', population: 4321 },
      { name: 'Beckerich', slug: 'beckerich-lux', population: 2234 },
      { name: 'Wahl', slug: 'wahl', population: 1567 },
      { name: 'Lac de la Haute-Sûre', slug: 'lac-de-la-haute-sure', population: 3876 },
      { name: 'Kiischpelt', slug: 'kiischpelt', population: 1234 },
      { name: 'Wiltz', slug: 'wiltz', population: 6789 },
      { name: 'Winseler', slug: 'winseler', population: 987 },
      { name: 'Esch-sur-Sûre', slug: 'esch-sur-sure', population: 1654 },
      { name: 'Goesdorf', slug: 'goesdorf', population: 1876 },
      { name: 'Heiderscheid', slug: 'heiderscheid', population: 876 },
      { name: 'Neunhausen', slug: 'neunhausen', population: 654 },
      { name: 'Eschweiler', slug: 'eschweiler', population: 1234 },
      { name: 'Wilwerwiltz', slug: 'wilwerwiltz', population: 987 },
      { name: 'Clervaux', slug: 'clervaux', population: 2876 },
      { name: 'Parc Hosingen', slug: 'parc-hosingen', population: 1654 },
      { name: 'Consthum', slug: 'consthum', population: 876 },
      { name: 'Munshausen', slug: 'munshausen', population: 1345 },
      { name: 'Troisvierges', slug: 'troisvierges', population: 2987 },
      { name: 'Weiswampach', slug: 'weiswampach', population: 1567 },
      { name: 'Putscheid', slug: 'putscheid', population: 987 },
      { name: 'Tandel', slug: 'tandel', population: 1876 },
      { name: 'Vianden', slug: 'vianden', population: 1987 },
      { name: 'Beaufort', slug: 'beaufort', population: 2345 },
      { name: 'Berdorf', slug: 'berdorf', population: 1456 },
      { name: 'Consdorf', slug: 'consdorf', population: 2876 },
      { name: 'Echternach', slug: 'echternach', population: 5432 },
      { name: 'Rosport-Mompach', slug: 'rosport-mompach', population: 1987 },
      { name: 'Mompach', slug: 'mompach', population: 1234 },
      { name: 'Born', slug: 'born', population: 876 },
      { name: 'Waldbillig', slug: 'waldbillig', population: 1456 },
      { name: 'Ernzen', slug: 'ernzen', population: 654 },
      { name: 'Bech', slug: 'bech', population: 987 },
      { name: 'Junglinster', slug: 'junglinster', population: 7234 },
      { name: 'Grevenmacher', slug: 'grevenmacher', population: 5098 },
      { name: 'Mertert', slug: 'mertert', population: 4876 },
      { name: 'Flaxweiler', slug: 'flaxweiler', population: 2345 },
      { name: 'Betzdorf', slug: 'betzdorf', population: 3876 },
      { name: 'Roeser', slug: 'roeser-2', population: 6298 },
      { name: 'Niederanven', slug: 'niederanven', population: 6543 },
      { name: 'Schuttrange', slug: 'schuttrange', population: 4123 },
      { name: 'Canach', slug: 'canach', population: 1876 },
      { name: 'Lenningen', slug: 'lenningen', population: 2345 },
      { name: 'Wormeldange', slug: 'wormeldange', population: 2987 },
      { name: 'Ahn', slug: 'ahn', population: 1234 },
      { name: 'Stadtbredimus', slug: 'stadtbredimus', population: 1567 },
      { name: 'Remich', slug: 'remich', population: 3456 },
      { name: 'Bous', slug: 'bous', population: 1876 },
      { name: 'Waldbredimus', slug: 'waldbredimus', population: 987 },
      { name: 'Burmerange', slug: 'burmerange', population: 654 },
      { name: 'Wellenstein', slug: 'wellenstein', population: 876 },
      { name: 'Schengen', slug: 'schengen', population: 5432 },
      { name: 'Perl', slug: 'perl', population: 876 },
      { name: 'Mondorf-les-Bains', slug: 'mondorf-les-bains', population: 4876 },
      { name: 'Altwies', slug: 'altwies', population: 1234 },
      { name: 'Aspelt', slug: 'aspelt', population: 987 },
      { name: 'Frisange', slug: 'frisange', population: 4321 }
    ]
  },
  {
    code: 'MT',
    name: 'Malta',
    slug: 'malta',
    population: 518536,
    topCities: [
      { name: 'Valletta', slug: 'valletta', population: 5827 },
      { name: 'Birgu', slug: 'birgu', population: 2629 },
      { name: 'Senglea', slug: 'senglea', population: 2720 },
      { name: 'Cospicua', slug: 'cospicua', population: 5395 },
      { name: 'Paola', slug: 'paola', population: 8706 },
      { name: 'Tarxien', slug: 'tarxien', population: 8583 },
      { name: 'Fgura', slug: 'fgura', population: 11676 },
      { name: 'Żabbar', slug: 'zabbar', population: 14694 },
      { name: 'Marsaxlokk', slug: 'marsaxlokk', population: 3534 },
      { name: 'Żejtun', slug: 'zejtun', population: 11218 },
      { name: 'Marsaskala', slug: 'marsaskala', population: 13016 },
      { name: 'Ħamrun', slug: 'hamrun', population: 9244 },
      { name: 'Marsa', slug: 'marsa', population: 6500 },
      { name: 'Qormi', slug: 'qormi', population: 16324 },
      { name: 'Żebbuġ', slug: 'zebbug', population: 11903 },
      { name: 'Siġġiewi', slug: 'siggiewi', population: 8423 },
      { name: 'Żurrieq', slug: 'zurrieq', population: 11823 },
      { name: 'Mqabba', slug: 'mqabba', population: 3264 },
      { name: 'Qrendi', slug: 'qrendi', population: 2527 },
      { name: 'Kirkop', slug: 'kirkop', population: 2192 },
      { name: 'Luqa', slug: 'luqa', population: 6028 },
      { name: 'Gudja', slug: 'gudja', population: 3054 },
      { name: 'Għaxaq', slug: 'ghaxaq', population: 4915 },
      { name: 'Santa Luċija', slug: 'santa-lucija', population: 3239 },
      { name: 'Floriana', slug: 'floriana', population: 2205 },
      { name: 'Birkirkara', slug: 'birkirkara', population: 24356 },
      { name: 'Ħ\'Attard', slug: 'hattard', population: 12268 },
      { name: 'San Ġwann', slug: 'san-gwann', population: 13674 },
      { name: 'Ta\' Xbiex', slug: 'ta-xbiex', population: 1982 },
      { name: 'Msida', slug: 'msida', population: 7623 },
      { name: 'Gżira', slug: 'gzira', population: 7964 },
      { name: 'Sliema', slug: 'sliema', population: 19712 },
      { name: 'Pieta', slug: 'pieta', population: 4177 },
      { name: 'St. Julian\'s', slug: 'st-julians', population: 13792 },
      { name: 'Pembroke', slug: 'pembroke', population: 3417 },
      { name: 'Swieqi', slug: 'swieqi', population: 11956 },
      { name: 'Madliena', slug: 'madliena', population: 1876 },
      { name: 'Ibraġ', slug: 'ibrag', population: 3654 },
      { name: 'San Ġiljan', slug: 'san-giljan', population: 13792 },
      { name: 'Balzan', slug: 'balzan', population: 4774 },
      { name: 'Lija', slug: 'lija', population: 3385 },
      { name: 'Iklin', slug: 'iklin', population: 3247 },
      { name: 'Naxxar', slug: 'naxxar', population: 14891 },
      { name: 'San Pawl il-Baħar', slug: 'san-pawl-il-bahar', population: 32042 },
      { name: 'Buġibba', slug: 'bugibba', population: 14658 },
      { name: 'Qawra', slug: 'qawra', population: 3876 },
      { name: 'Xemxija', slug: 'xemxija', population: 2345 },
      { name: 'Burmarrad', slug: 'burmarrad', population: 6543 },
      { name: 'Bidnija', slug: 'bidnija', population: 876 },
      { name: 'Mistra', slug: 'mistra', population: 1234 },
      { name: 'Pwales', slug: 'pwales', population: 654 },
      { name: 'Salina', slug: 'salina', population: 2876 },
      { name: 'Buġibba', slug: 'bugibba-2', population: 14658 },
      { name: 'Mosta', slug: 'mosta', population: 20241 },
      { name: 'Wardija', slug: 'wardija', population: 1876 },
      { name: 'Ta\' Qali', slug: 'ta-qali', population: 2345 },
      { name: 'Ħal Għargħur', slug: 'hal-gharghar', population: 2768 },
      { name: 'Bidnija', slug: 'bidnija-2', population: 876 },
      { name: 'Magħtab', slug: 'maghtab', population: 1234 },
      { name: 'San Martin', slug: 'san-martin', population: 987 },
      { name: 'Kappara', slug: 'kappara', population: 3456 },
      { name: 'Baħar iċ-Ċagħaq', slug: 'bahar-ic-caghaq', population: 4123 },
      { name: 'Għargħur', slug: 'gharghar', population: 2768 },
      { name: 'Mellieħa', slug: 'mellieha', population: 10087 },
      { name: 'Marfa', slug: 'marfa', population: 876 },
      { name: 'Għadira', slug: 'ghadira', population: 2345 },
      { name: 'Armier', slug: 'armier', population: 654 },
      { name: 'Paradise Bay', slug: 'paradise-bay', population: 432 },
      { name: 'Ċirkewwa', slug: 'cirkewwa', population: 987 },
      { name: 'Il-Mellieħa', slug: 'il-mellieha', population: 10087 },
      { name: 'Għajn Tuffieħa', slug: 'ghajn-tuffieha', population: 234 },
      { name: 'Golden Bay', slug: 'golden-bay', population: 567 },
      { name: 'Manikata', slug: 'manikata', population: 2876 },
      { name: 'Żebbiegħ', slug: 'zebbiegh', population: 1234 },
      { name: 'Tal-Virtù', slug: 'tal-virtu', population: 987 },
      { name: 'Ħal Lija', slug: 'hal-lija', population: 3385 },
      { name: 'Ħad-Dingli', slug: 'had-dingli', population: 3326 },
      { name: 'Ħal Balzan', slug: 'hal-balzan', population: 4774 },
      { name: 'Ħal Għargħur', slug: 'hal-gharghar-2', population: 2768 },
      { name: 'Mdina', slug: 'mdina', population: 306 },
      { name: 'Rabat', slug: 'rabat', population: 11497 },
      { name: 'Dingli', slug: 'dingli', population: 3326 },
      { name: 'Baħrija', slug: 'bahrija', population: 4567 },
      { name: 'Ħal Farruġ', slug: 'hal-farrug', population: 3876 },
      { name: 'Mtarfa', slug: 'mtarfa', population: 2572 },
      { name: 'Binġemma', slug: 'bingemma', population: 1234 },
      { name: 'Bidnija', slug: 'bidnija-3', population: 876 },
      { name: 'Tal-Virtù', slug: 'tal-virtu-2', population: 987 },
      { name: 'Victoria', slug: 'victoria', population: 6901 },
      { name: 'Xewkija', slug: 'xewkija', population: 3486 },
      { name: 'Żebbuġ', slug: 'zebbug-gozo', population: 1854 },
      { name: 'Għarb', slug: 'gharb', population: 1539 },
      { name: 'Ghasri', slug: 'ghasri', population: 525 },
      { name: 'Għasri', slug: 'ghasri-2', population: 525 },
      { name: 'Kerċem', slug: 'kercem', population: 1873 },
      { name: 'Munxar', slug: 'munxar', population: 1454 },
      { name: 'Qala', slug: 'qala', population: 1906 },
      { name: 'San Lawrenz', slug: 'san-lawrenz', population: 748 },
      { name: 'Sannat', slug: 'sannat', population: 2327 },
      { name: 'Xagħra', slug: 'xaghra', population: 4582 },
      { name: 'Xewkija', slug: 'xewkija-2', population: 3486 },
      { name: 'Nadur', slug: 'nadur', population: 4509 },
      { name: 'Qala', slug: 'qala-2', population: 1906 },
      { name: 'Għajnsielem', slug: 'ghajnsielem', population: 3200 },
      { name: 'Fontana', slug: 'fontana', population: 987 },
      { name: 'Xlendi', slug: 'xlendi', population: 1234 },
      { name: 'Marsalforn', slug: 'marsalforn', population: 2876 },
      { name: 'Ramla Bay', slug: 'ramla-bay', population: 345 },
      { name: 'Dwejra', slug: 'dwejra', population: 123 },
      { name: 'Ta\' Pinu', slug: 'ta-pinu', population: 567 }
    ]
  },
  {
    code: 'IS',
    name: 'Iceland',
    slug: 'iceland',
    population: 376248,
    topCities: [
      { name: 'Reykjavik', slug: 'reykjavik', population: 131136 },
      { name: 'Kopavogur', slug: 'kopavogur', population: 37159 },
      { name: 'Hafnarfjordur', slug: 'hafnarfjordur', population: 29799 },
      { name: 'Akureyri', slug: 'akureyri', population: 18191 },
      { name: 'Reykjanesbaer', slug: 'reykjanesbaer', population: 18920 },
      { name: 'Gardabaer', slug: 'gardabaer', population: 16299 },
      { name: 'Mosfellsbaer', slug: 'mosfellsbaer', population: 11463 },
      { name: 'Arborg', slug: 'arborg', population: 9485 },
      { name: 'Akranes', slug: 'akranes', population: 7411 },
      { name: 'Fjarðabyggð', slug: 'fjardabyggd', population: 4599 },
      { name: 'Mulathing', slug: 'mulathing', population: 4280 },
      { name: 'Seltjarnarnes', slug: 'seltjarnarnes', population: 4395 },
      { name: 'Vogar', slug: 'vogar', population: 1273 },
      { name: 'Hveragerdi', slug: 'hveragerdi', population: 2581 },
      { name: 'Isafjordur', slug: 'isafjordur', population: 2624 },
      { name: 'Vestmannaeyjar', slug: 'vestmannaeyjar', population: 4414 },
      { name: 'Þorlákshöfn', slug: 'thorlakshofn', population: 1666 },
      { name: 'Egilsstaðir', slug: 'egilsstadir', population: 2306 },
      { name: 'Selfoss', slug: 'selfoss', population: 7817 },
      { name: 'Húsavík', slug: 'husavik', population: 2307 },
      { name: 'Sandgerði', slug: 'sandgerdi', population: 1775 },
      { name: 'Grindavík', slug: 'grindavik', population: 3669 },
      { name: 'Ólafsvík', slug: 'olafsvik', population: 1010 },
      { name: 'Stykkishólmur', slug: 'stykkisholmur', population: 1172 },
      { name: 'Dalvík', slug: 'dalvik', population: 1391 },
      { name: 'Siglufjörður', slug: 'siglufjordur', population: 1102 },
      { name: 'Sauðárkrókur', slug: 'saudarkrokur', population: 2612 },
      { name: 'Blönduós', slug: 'blonduos', population: 874 },
      { name: 'Höfn', slug: 'hofn', population: 2365 },
      { name: 'Vík í Mýrdal', slug: 'vik-i-myrdal', population: 291 },
      { name: 'Kirkjubæjarklaustur', slug: 'kirkjubaejarklaustur', population: 117 },
      { name: 'Jökulsárlón', slug: 'jokulsarlon', population: 25 },
      { name: 'Vatnajökull', slug: 'vatnajokull', population: 10 },
      { name: 'Hallormsstadur', slug: 'hallormsstadur', population: 56 },
      { name: 'Djúpivogur', slug: 'djupivogur', population: 452 },
      { name: 'Reyðarfjörður', slug: 'reydarfjordur', population: 1102 },
      { name: 'Eskifjörður', slug: 'eskifjordur', population: 1043 },
      { name: 'Neskaupstaður', slug: 'neskaupstadur', population: 1437 },
      { name: 'Seyðisfjörður', slug: 'seydisfjordur', population: 668 },
      { name: 'Borgarfjörður eystri', slug: 'borgarfjordur-eystri', population: 116 },
      { name: 'Vopnafjörður', slug: 'vopnafjordur', population: 688 },
      { name: 'Þórshöfn', slug: 'thorshofn', population: 380 },
      { name: 'Raufarhöfn', slug: 'raufarhofn', population: 188 },
      { name: 'Kópasker', slug: 'kopasker', population: 123 },
      { name: 'Ásbyrgi', slug: 'asbygi', population: 15 },
      { name: 'Dettifoss', slug: 'dettifoss', population: 5 },
      { name: 'Mývatn', slug: 'myvatn', population: 87 },
      { name: 'Goðafoss', slug: 'godafoss', population: 12 },
      { name: 'Ólafsfjörður', slug: 'olafsfjordur', population: 789 },
      { name: 'Grenivík', slug: 'grenivik', population: 301 },
      { name: 'Grimsey', slug: 'grimsey', population: 61 },
      { name: 'Flatey', slug: 'flatey', population: 2 },
      { name: 'Drangey', slug: 'drangey', population: 0 },
      { name: 'Hofsos', slug: 'hofsos', population: 188 },
      { name: 'Varmahlid', slug: 'varmahlid', population: 156 },
      { name: 'Hvammstangi', slug: 'hvammstangi', population: 580 },
      { name: 'Borgarnes', slug: 'borgarnes', population: 1759 },
      { name: 'Reykholt', slug: 'reykholt', population: 234 },
      { name: 'Deildartunguhver', slug: 'deildartunguhver', population: 25 },
      { name: 'Hraunfossar', slug: 'hraunfossar', population: 8 },
      { name: 'Barnafoss', slug: 'barnafoss', population: 5 },
      { name: 'Langjökull', slug: 'langjokull', population: 2 },
      { name: 'Þingvellir', slug: 'thingvellir', population: 45 },
      { name: 'Gullfoss', slug: 'gullfoss', population: 15 },
      { name: 'Geysir', slug: 'geysir', population: 28 },
      { name: 'Skálholt', slug: 'skalholt', population: 34 },
      { name: 'Flúðir', slug: 'fludir', population: 423 },
      { name: 'Laugarvatn', slug: 'laugarvatn', population: 234 },
      { name: 'Eyrarbakki', slug: 'eyrarbakki', population: 570 },
      { name: 'Stokkseyri', slug: 'stokkseyri', population: 555 },
      { name: 'Þorlákshöfn', slug: 'thorlakshofn-2', population: 1666 },
      { name: 'Krísuvík', slug: 'krisuvik', population: 125 },
      { name: 'Blue Lagoon', slug: 'blue-lagoon', population: 150 },
      { name: 'Garður', slug: 'gardur', population: 1543 },
      { name: 'Keflavík', slug: 'keflavik', population: 15129 },
      { name: 'Njarðvík', slug: 'njardvik', population: 4400 },
      { name: 'Hafnir', slug: 'hafnir', population: 120 },
      { name: 'Reykjanes', slug: 'reykjanes', population: 89 },
      { name: 'Eldey', slug: 'eldey', population: 0 },
      { name: 'Snæfellsjökull', slug: 'snaefellsjokull', population: 5 },
      { name: 'Hellnar', slug: 'hellnar', population: 67 },
      { name: 'Arnarstapi', slug: 'arnarstapi', population: 123 },
      { name: 'Djúpalónssandur', slug: 'djupalonssandur', population: 8 },
      { name: 'Dritvík', slug: 'dritvik', population: 3 },
      { name: 'Rif', slug: 'rif', population: 167 },
      { name: 'Hellissandur', slug: 'hellissandur', population: 489 },
      { name: 'Ólafsvík', slug: 'olafsvik-2', population: 1010 },
      { name: 'Grundarfjörður', slug: 'grundarfjordur', population: 872 },
      { name: 'Kirkjufell', slug: 'kirkjufell', population: 12 },
      { name: 'Búðir', slug: 'budir', population: 45 },
      { name: 'Lýsuhóll', slug: 'lysuholl', population: 23 },
      { name: 'Ytri Tunga', slug: 'ytri-tunga', population: 15 },
      { name: 'Bjarnahöfn', slug: 'bjarnahofn', population: 78 },
      { name: 'Bjarnarhöfn', slug: 'bjarnarhofn', population: 34 },
      { name: 'Gufuskálar', slug: 'gufuskalar', population: 56 },
      { name: 'Eldborg', slug: 'eldborg', population: 12 },
      { name: 'Gerðuberg', slug: 'gerduberg', population: 8 },
      { name: 'Álftavatn', slug: 'alftavatn', population: 23 },
      { name: 'Berserkjahraun', slug: 'berserkjahraun', population: 5 },
      { name: 'Flatey', slug: 'flatey-2', population: 5 },
      { name: 'Breiðafjörður', slug: 'breidafjordur', population: 123 },
      { name: 'Víðey', slug: 'videy', population: 12 },
      { name: 'Engey', slug: 'engey', population: 8 },
      { name: 'Þórufoss', slug: 'thorufoss', population: 23 },
      { name: 'Glymur', slug: 'glymur', population: 15 },
      { name: 'Esja', slug: 'esja', population: 34 },
      { name: 'Þríhnúkagígur', slug: 'thrihnukagigur', population: 5 }
    ]
  },
  {
    code: 'AD',
    name: 'Andorra',
    slug: 'andorra',
    population: 79218,
    topCities: [
      { name: 'Andorra la Vella', slug: 'andorra-la-vella', population: 22886 },
      { name: 'Escaldes-Engordany', slug: 'escaldes-engordany', population: 14395 },
      { name: 'Encamp', slug: 'encamp', population: 13295 },
      { name: 'Sant Julià de Lòria', slug: 'sant-julia-de-loria', population: 9595 },
      { name: 'La Massana', slug: 'la-massana', population: 10784 },
      { name: 'Santa Coloma d\'Andorra', slug: 'santa-coloma-dandorra', population: 3554 },
      { name: 'Ordino', slug: 'ordino', population: 5637 },
      { name: 'El Tarter', slug: 'el-tarter', population: 1234 },
      { name: 'Soldeu', slug: 'soldeu', population: 876 },
      { name: 'Grau Roig', slug: 'grau-roig', population: 234 },
      { name: 'Pas de la Casa', slug: 'pas-de-la-casa', population: 2363 },
      { name: 'Canillo', slug: 'canillo', population: 4826 },
      { name: 'Meritxell', slug: 'meritxell', population: 1234 },
      { name: 'El Serrat', slug: 'el-serrat', population: 876 },
      { name: 'Llorts', slug: 'llorts', population: 345 },
      { name: 'La Cortinada', slug: 'la-cortinada', population: 987 },
      { name: 'Ansalonga', slug: 'ansalonga', population: 456 },
      { name: 'Segudet', slug: 'segudet', population: 234 },
      { name: 'Sornàs', slug: 'sornas', population: 567 },
      { name: 'Arinsal', slug: 'arinsal', population: 1876 },
      { name: 'Pal', slug: 'pal', population: 654 },
      { name: 'Erts', slug: 'erts', population: 432 },
      { name: 'La Massana Village', slug: 'la-massana-village', population: 2345 },
      { name: 'Anyós', slug: 'anyos', population: 1234 },
      { name: 'Sispony', slug: 'sispony', population: 876 },
      { name: 'Xixerella', slug: 'xixerella', population: 543 },
      { name: 'El Forn', slug: 'el-forn', population: 321 },
      { name: 'L\'Aldosa', slug: 'laldosa', population: 987 },
      { name: 'Bixessarri', slug: 'bixessarri', population: 654 },
      { name: 'Juberri', slug: 'juberri', population: 432 },
      { name: 'Fontaneda', slug: 'fontaneda', population: 765 },
      { name: 'Aixàs', slug: 'aixas', population: 234 },
      { name: 'Certers', slug: 'certers', population: 567 },
      { name: 'Llumeneres', slug: 'llumeneres', population: 123 },
      { name: 'Aixovall', slug: 'aixovall', population: 876 },
      { name: 'Nagol', slug: 'nagol', population: 345 },
      { name: 'Os de Civís', slug: 'os-de-civis', population: 65 },
      { name: 'Borda', slug: 'borda', population: 234 },
      { name: 'Aubinyà', slug: 'aubinya', population: 432 },
      { name: 'Ransol', slug: 'ransol', population: 876 },
      { name: 'Incles', slug: 'incles', population: 543 },
      { name: 'Bordes d\'Envalira', slug: 'bordes-denvalira', population: 123 },
      { name: 'L\'Aldosa de Canillo', slug: 'laldosa-de-canillo', population: 345 },
      { name: 'Prats', slug: 'prats', population: 234 },
      { name: 'Montaup', slug: 'montaup', population: 567 },
      { name: 'Els Plans', slug: 'els-plans', population: 432 },
      { name: 'Roc de Sant Pere', slug: 'roc-de-sant-pere', population: 123 },
      { name: 'La Pleta', slug: 'la-pleta', population: 876 },
      { name: 'Pessons', slug: 'pessons', population: 234 },
      { name: 'Font-Romeu', slug: 'font-romeu', population: 345 },
      { name: 'Cortals', slug: 'cortals', population: 567 },
      { name: 'Llac de Pessons', slug: 'llac-de-pessons', population: 123 },
      { name: 'Coma Pedrosa', slug: 'coma-pedrosa', population: 45 },
      { name: 'Pic de Casamanya', slug: 'pic-de-casamanya', population: 23 },
      { name: 'Tristaina', slug: 'tristaina', population: 234 },
      { name: 'Estany de Tristaina', slug: 'estany-de-tristaina', population: 56 },
      { name: 'Ruta del Ferro', slug: 'ruta-del-ferro', population: 123 },
      { name: 'Sorteny', slug: 'sorteny', population: 345 },
      { name: 'Vall del Madriu', slug: 'vall-del-madriu', population: 67 },
      { name: 'Pic de la Serrera', slug: 'pic-de-la-serrera', population: 34 },
      { name: 'Roc del Quer', slug: 'roc-del-quer', population: 123 },
      { name: 'Mirador del Roc del Quer', slug: 'mirador-del-roc-del-quer', population: 45 },
      { name: 'Camí del Rec del Solà', slug: 'cami-del-rec-del-sola', population: 234 },
      { name: 'Telecabina de Soldeu', slug: 'telecabina-de-soldeu', population: 56 },
      { name: 'TSD Espiolets', slug: 'tsd-espiolets', population: 78 },
      { name: 'Tosa d\'Alp', slug: 'tosa-dalp', population: 123 },
      { name: 'Pic d\'Encampadana', slug: 'pic-dencampadana', population: 34 },
      { name: 'Els Cortals d\'Encamp', slug: 'els-cortals-dencamp', population: 234 },
      { name: 'Funicamp', slug: 'funicamp', population: 567 },
      { name: 'Llac d\'Engolasters', slug: 'llac-dengolasters', population: 89 },
      { name: 'Pic del Pessó', slug: 'pic-del-pesso', population: 23 },
      { name: 'Collada de Juclar', slug: 'collada-de-juclar', population: 45 },
      { name: 'Estanys de Juclar', slug: 'estanys-de-juclar', population: 12 },
      { name: 'Pic de Maià', slug: 'pic-de-maia', population: 67 },
      { name: 'Refugi de l\'Illa', slug: 'refugi-de-lilla', population: 23 },
      { name: 'Collada dels Meners', slug: 'collada-dels-meners', population: 45 },
      { name: 'Port d\'Envalira', slug: 'port-denvalira', population: 123 },
      { name: 'Coll de la Botella', slug: 'coll-de-la-botella', population: 34 },
      { name: 'Coll d\'Ordino', slug: 'coll-dordino', population: 56 },
      { name: 'Coll de la Gallina', slug: 'coll-de-la-gallina', population: 78 },
      { name: 'Port del Rat', slug: 'port-del-rat', population: 23 },
      { name: 'Coll de Beixalís', slug: 'coll-de-beixalis', population: 45 },
      { name: 'Portella Blanca d\'Andorra', slug: 'portella-blanca-dandorra', population: 12 },
      { name: 'Pic de Sanfonts', slug: 'pic-de-sanfonts', population: 34 },
      { name: 'Pic de l\'Estanyó', slug: 'pic-de-lestanyo', population: 56 },
      { name: 'Pic de Monturull', slug: 'pic-de-monturull', population: 23 },
      { name: 'Pic de Ribuls', slug: 'pic-de-ribuls', population: 45 },
      { name: 'Pic de Cataperdís', slug: 'pic-de-cataperdis', population: 67 },
      { name: 'Bony de la Pica', slug: 'bony-de-la-pica', population: 89 },
      { name: 'Pic de l\'Àliga', slug: 'pic-de-laliga', population: 34 },
      { name: 'Pic de Font Blanca', slug: 'pic-de-font-blanca', population: 56 },
      { name: 'Coll de les Cases', slug: 'coll-de-les-cases', population: 78 },
      { name: 'Pic de Creussans', slug: 'pic-de-creussans', population: 23 },
      { name: 'Pic de Siguer', slug: 'pic-de-siguer', population: 45 },
      { name: 'Serrat de les Esposes', slug: 'serrat-de-les-esposes', population: 12 },
      { name: 'Coma de Varilles', slug: 'coma-de-varilles', population: 67 },
      { name: 'Roca Entravessada', slug: 'roca-entravessada', population: 34 },
      { name: 'Pic dels Pessons', slug: 'pic-dels-pessons', population: 56 },
      { name: 'Pic de la Cabaneta', slug: 'pic-de-la-cabaneta', population: 78 },
      { name: 'Pic Blanc de Nèges', slug: 'pic-blanc-de-neges', population: 23 },
      { name: 'Pic de la Portelleta', slug: 'pic-de-la-portelleta', population: 45 },
      { name: 'Agulles d\'Engolasters', slug: 'agulles-dengolasters', population: 12 },
      { name: 'Roc de la Sabina', slug: 'roc-de-la-sabina', population: 34 },
      { name: 'Pic de Carroi', slug: 'pic-de-carroi', population: 56 },
      { name: 'Pic Alt del Cubil', slug: 'pic-alt-del-cubil', population: 78 }
    ]
  },
  {
    code: 'SM',
    name: 'San Marino',
    slug: 'san-marino',
    population: 34017,
    topCities: [
      { name: 'City of San Marino', slug: 'city-of-san-marino', population: 4044 },
      { name: 'Serravalle', slug: 'serravalle', population: 10878 },
      { name: 'Borgo Maggiore', slug: 'borgo-maggiore', population: 6871 },
      { name: 'Domagnano', slug: 'domagnano', population: 3565 },
      { name: 'Fiorentino', slug: 'fiorentino', population: 2548 },
      { name: 'Acquaviva', slug: 'acquaviva', population: 2014 },
      { name: 'Faetano', slug: 'faetano', population: 1177 },
      { name: 'Chiesanuova', slug: 'chiesanuova', population: 1105 },
      { name: 'Montegiardino', slug: 'montegiardino', population: 815 },
      { name: 'Falciano', slug: 'falciano', population: 1876 },
      { name: 'Dogana', slug: 'dogana', population: 6800 },
      { name: 'Murata', slug: 'murata', population: 3456 },
      { name: 'Ca\' Ragni', slug: 'ca-ragni', population: 2234 },
      { name: 'Rovereta', slug: 'rovereta', population: 1987 },
      { name: 'Galazzano', slug: 'galazzano', population: 1654 },
      { name: 'Cailungo', slug: 'cailungo', population: 1432 },
      { name: 'Valdragone', slug: 'valdragone', population: 1234 },
      { name: 'Ventoso', slug: 'ventoso', population: 987 },
      { name: 'Lesignano', slug: 'lesignano', population: 876 },
      { name: 'Gualdicciolo', slug: 'gualdicciolo', population: 765 },
      { name: 'Ca\' Melone', slug: 'ca-melone', population: 654 },
      { name: 'Torraccia', slug: 'torraccia', population: 543 },
      { name: 'Spaccio', slug: 'spaccio', population: 432 },
      { name: 'Teglio', slug: 'teglio', population: 345 },
      { name: 'Corianino', slug: 'corianino', population: 234 },
      { name: 'Cerbaiola', slug: 'cerbaiola', population: 567 },
      { name: 'Montalbo', slug: 'montalbo', population: 456 },
      { name: 'Ponte Mellini', slug: 'ponte-mellini', population: 345 },
      { name: 'Ca\' Chiavello', slug: 'ca-chiavello', population: 234 },
      { name: 'Montecchio', slug: 'montecchio', population: 876 },
      { name: 'Ca\' Rigo', slug: 'ca-rigo', population: 654 },
      { name: 'Cà dei Lunghi', slug: 'ca-dei-lunghi', population: 543 },
      { name: 'La Serra', slug: 'la-serra', population: 432 },
      { name: 'Castellaro', slug: 'castellaro', population: 345 },
      { name: 'Cinque Vie', slug: 'cinque-vie', population: 234 },
      { name: 'Teglio Alto', slug: 'teglio-alto', population: 567 },
      { name: 'Capanne', slug: 'capanne', population: 456 },
      { name: 'Casole', slug: 'casole', population: 345 },
      { name: 'Tavolucci', slug: 'tavolucci', population: 234 },
      { name: 'Cerasolo', slug: 'cerasolo', population: 876 },
      { name: 'Fondo Ausa', slug: 'fondo-ausa', population: 654 },
      { name: 'Canepa', slug: 'canepa', population: 543 },
      { name: 'Ca\' Martino', slug: 'ca-martino', population: 432 },
      { name: 'Falciano Alto', slug: 'falciano-alto', population: 345 },
      { name: 'Ca\' Bandino', slug: 'ca-bandino', population: 234 },
      { name: 'Gesso', slug: 'gesso', population: 567 },
      { name: 'Ca\' Giannino', slug: 'ca-giannino', population: 456 },
      { name: 'Poggiale', slug: 'poggiale', population: 345 },
      { name: 'Ca\' Berlone', slug: 'ca-berlone', population: 234 },
      { name: 'Crociale', slug: 'crociale', population: 876 },
      { name: 'Galavotto', slug: 'galavotto', population: 654 },
      { name: 'Valgiurata', slug: 'valgiurata', population: 543 },
      { name: 'Poggio Casalino', slug: 'poggio-casalino', population: 432 },
      { name: 'Fonte dell\'Ovo', slug: 'fonte-dellovo', population: 345 },
      { name: 'Poggio Chiesanuova', slug: 'poggio-chiesanuova', population: 234 },
      { name: 'Canepa Alta', slug: 'canepa-alta', population: 123 },
      { name: 'Caiadello', slug: 'caiadello', population: 213 },
      { name: 'Piandavello', slug: 'piandavello', population: 312 },
      { name: 'Maiano', slug: 'maiano', population: 87 },
      { name: 'Montelupo', slug: 'montelupo', population: 78 },
      { name: 'Cà Bertone', slug: 'ca-bertone', population: 45 },
      { name: 'La Dogana', slug: 'la-dogana', population: 56 },
      { name: 'Casenuove', slug: 'casenuove', population: 67 },
      { name: 'Coroncino', slug: 'coroncino', population: 78 },
      { name: 'Il Poggio', slug: 'il-poggio', population: 89 }
    ]
  }
]
